import React from 'react';
import './instapagostStyle.css';

function ProductClientData({productData, saleOrderData, tasaBancaria, initialPaymentTerm}) {
    
    const truncateFixed = (num, decimals) => {
        const factor = Math.pow(10, decimals); // Calcula 10^decimals (10 elevado a los decimales deseados)
        return Math.trunc(num * factor) / factor; // Multiplica, trunca y luego divide para mantener los decimales
    };
    const orderDataProductsDetails = {
        subTotal: truncateFixed(saleOrderData[0].amount_untaxed, 2),
        iva: truncateFixed(saleOrderData[0].amount_tax, 2),
        totalAmount: truncateFixed(saleOrderData[0].amount_total, 2),
        missing: truncateFixed(saleOrderData[0].amount_residual, 2),
    }
    const roundUpSecondDecimal = (amount) => {
        return Math.ceil(amount * 100) / 100; // Redondea siempre hacia arriba en el segundo decimal
    }
    const amountTotalInBs = (totalValue) =>{
        let value = 0;
        if(!totalValue) value = orderDataProductsDetails.missing * tasaBancaria
        else value = totalValue * tasaBancaria
        return truncateFixed(roundUpSecondDecimal(value) ,2)
    }
    const amountTotalParcialPay = () =>{
        const initialPaymentTermData = initialPaymentTerm.initial;
        if(initialPaymentTermData && initialPaymentTermData.amount){
            if( initialPaymentTermData.amount < orderDataProductsDetails.totalAmount){
                console.log(initialPaymentTermData.amount < orderDataProductsDetails.totalAmount, "initialPaymentTermData.amount < orderDataProductsDetails.totalAmount")
                return initialPaymentTermData.amount
            }else {
                return orderDataProductsDetails.totalAmount
            }
        }
        console.log(orderDataProductsDetails.totalAmount, "orderDataProductsDetails.totalAmount")
        return orderDataProductsDetails.totalAmount
    }
    const faltante = orderDataProductsDetails.missing !== orderDataProductsDetails.totalAmount;
  return (
    <div className='container px-0'> 
        <div className="row">
            <div className="col-12 px-0">
                <table className="table table-striped mb-4 " style={{borderBottom:'1px solid #b5b5b5', boxShadow: '1px 1px 5px 4px #00000029', borderRadius: '.35rem'}}>
                    <thead>
                        <tr>
                        <th scope="col" className='d-none d-md-block'>#</th>
                        <th scope="col">Nombre del producto</th>
                        <th scope="col">Cantidad</th>
                        <th scope="col">Precio</th>
                        <th scope="col">SubTotal</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            productData.map((value, index)=>(
                                <tr key={index}>
                                    <th scope="row" className='d-none d-md-block'>{index+1}</th>
                                    <td>{value.product_id[1]}</td>
                                    <td>{value.quantity}</td>
                                    <td>{truncateFixed(value.price_unit, 2)}$</td>
                                    <td>{truncateFixed(value.price_subtotal, 2)}$</td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
                <div className="totalPrice w-full ml-auto" style={{maxWidth:320, boxShadow: '2px 7px 6px 0px #00000029', borderRadius: '.35rem'}}>
                    <h4
                        className='text-center mb-0 '
                        style={{
                            background: '#014788',
                            color: 'white',
                            padding: '.65rem 0',
                            borderRadius: '.35rem .35rem 0 0'
                        }}
                    >
                        Resumen de pago
                    </h4>
                    <table className="table mb-0" style={{ fontSize: 15 }}>
                        {/* <thead>
                            <tr>
                                <th style={{ width: '40%' }}></th>
                                <th className="text-end" style={{ backgroundColor: '#f0f0f0' }}>$</th>
                                <th className="text-end" style={{ backgroundColor: '#f0f0f0' }}>Bs</th>
                            </tr>
                        </thead> */}
                        <tbody>
                            <tr style={{ backgroundColor: '#0000000d' }}>
                                <td><p className='m-0 fw-bold' style={{fontWeight:'600'}}>Subtotal:</p></td>
                                <td className="text-end">{orderDataProductsDetails.subTotal}$</td>
                                <td className="text-end">{amountTotalInBs(orderDataProductsDetails.subTotal)}Bs</td>
                            </tr>
                            <tr>
                                <td><p className='m-0 fw-bold' style={{fontWeight:'600'}}>IVA:</p></td>
                                <td className="text-end">{orderDataProductsDetails.iva}$</td>
                                <td className="text-end">{amountTotalInBs(orderDataProductsDetails.iva)}Bs</td>
                            </tr>

                            {
                               orderDataProductsDetails.totalAmount != amountTotalParcialPay() && (
                                <tr style={{ backgroundColor: '#0000000d' }}>
                                    <td><p className='m-0 fw-bold' style={{fontWeight:'600'}}>Monto total:</p></td>
                                    <td className="text-end">{orderDataProductsDetails.totalAmount}$</td>
                                    <td className="text-end">{amountTotalInBs()}Bs</td>
                                </tr>
                               )
                            }
                            {faltante && (
                                <tr>
                                    <td><p className='m-0 fw-bold' style={{fontWeight:'bold'}}>Faltante:</p></td>
                                    <td className="text-end fw-bold">{orderDataProductsDetails.missing}$</td>
                                    <td></td>
                                </tr>
                            )}
                            <tr>
                                <td>
                                    <p className='m-0 fw-bold' style={{fontWeight:'bold', fontSize:16}}>{faltante ? 'Faltante':'Total a pagar'}:</p>
                                </td>
                                <td className="text-end fw-bold">{amountTotalParcialPay()}$</td>
                                <td className="text-end fw-bold">{amountTotalInBs(amountTotalParcialPay())}Bs</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
  )
}

export default ProductClientData
